import { Card, CardContent, Typography, Box, useTheme, alpha } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import { Link } from 'react-router-dom';

interface PortalCardProps {
  title: string;
  linkText: string;
  to: string;
}

export const PortalCard = ({ title, linkText, to }: PortalCardProps) => {
  const theme = useTheme();

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <Card
        sx={{
          height: { xs: 'auto', md: '200px' },
          minHeight: { xs: '120px', md: '200px' },
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          border: `1px solid ${alpha(theme.palette.primary.dark, 0.2)}`,
          '&:hover, &:focus': {
            transform: 'translateY(-4px)',
            boxShadow: `0 8px 24px ${alpha(theme.palette.primary.dark, 0.2)}`,
            borderColor: theme.palette.primary.dark
          }
        }}
      >
        <CardContent
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            p: { xs: 2, md: 3 }
          }}
        >
          <Typography
            variant="h3"
            sx={{
              mb: { xs: 1, md: 2 }
            }}
          >
            {title}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              mt: 'auto'
            }}
          >
            <Typography
              variant="body1"
              sx={{
                mr: 1
              }}
            >
              {linkText}
            </Typography>
            <ArrowForward sx={{ fontSize: '1rem' }} />
          </Box>
        </CardContent>
      </Card>
    </Link>
  );
};
